define('controllers/consoleApi/apiKey.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('apiKeyCtrl', ['$q', '$scope', '$state','$rootScope','$stateParams','projectManageService','auiDialog',
        function ($q, $scope, $state,$rootScope,$stateParams,projectManageService,auiDialog) {

            var Model = $scope.Model = {
                forumDiversionConf: sysParamCfg.forumDiversionConf,
                projectID : $stateParams.projectID,
                clientID : $stateParams.clientID,
                projectKey : $stateParams.projectKey,
                apiKeyInfo : {},
                clientlist : [
                    {
                        packageName : '',
                        fingerprint : ''
                    }
                ],
                bundleIdlist:[
                    {
                        bundleId : ''
                    }
                ],
                URLlist: [
                    {
                        URL:''
                    }
                ],
                apiInfoList: [],
                apiIdSelect: {}
            };
            Model.apiSelect = [];
            $scope.regexp = mainCons.servicesConstant.regexp;
            $scope.addBundleIdlist = addBundleIdlist;
            $scope.delBundleIdList = delBundleIdList;
            $scope.addClientList = addClientList;
            $scope.delClientList = delClientList;
            $scope.addURLList = addURLList;
            $scope.delURLList = delURLList;
            $scope.cancel = cancel;
            $scope.delClient = delClient;

            $scope.doSubmit = doSubmit;

            init();
            function init() {
                projectManageService.getProjectCredentialList(Model.projectID,"1").then(function (resp) {
                    if (resp && resp.resultCode == "0") {
                        if (resp.apiKeyInfoList) {
                            Model.hasKeyInfo = true;
                            angular.forEach(resp.apiKeyInfoList,function(apiKey){
                                if(apiKey.clientID == Model.clientID){
                                    var apiLimits = apiKey.apiLimits ? apiKey.apiLimits:"";
                                    getApiList(apiLimits);
                                    if(apiKey.clientLimit){
                                        var clientLimit = JSON.parse(apiKey.clientLimit);
                                        switch(apiKey.clientTypeLimit){
                                            case 2: Model.URLlist = clientLimit.URLlist;break;
                                            case 3: Model.clientlist = clientLimit.clientlist;break;
                                            case 4: Model.bundleIdlist = clientLimit.bundleIdlist;break;
                                        }
                                    }
                                    Model.apiKeyInfo = apiKey;
                                    Model.apiKeyTypeOld = angular.copy(Model.apiKeyInfo.apiTypeLimit)
                                }
                            });
                        }
                    }
                });
            }

            //查询所有的API列表，并查询项目下面所有的api信息，对于已选择的api标记为已选中
            function getApiList(apiLimits) {
                var limits = apiLimits.split(",");
                projectManageService.getProjectAPI(Model.projectID).then(function (resp) {
                    if(resp && resp.apiInfoList){
                        angular.forEach(resp.apiInfoList,function(apiInfo){
                            var apiInfoBean = {
                                apiID: apiInfo.apiID,
                                apiName: apiInfo.langInfo.apiName,
                                selected:false
                            };
                            for(var i in limits){
                                if(limits[i] == apiInfo.apiID){
                                    Model.apiSelect.push(apiInfoBean);
                                }
                            }
                            Model.apiInfoList.push(apiInfoBean);
                        });
                    }
                });
            }

            function doSubmit(){
                var defer = $q.defer();
                // 取消表单初始为空不校验
                var formPropertys = Object.getOwnPropertyNames($scope.apiKeyForm);
                angular.forEach(formPropertys, function(property,index,array){
                    if(property.indexOf("$") !== 0){
                        $scope.apiKeyForm[property].$setDirty();
                    }
                });
                if($scope.apiKeyForm.$invalid){
                    defer.reject();
                    return false;
                }

                var request = {
                    projectID: Model.projectID,
                    clientID: Model.clientID,
                    clientTypeLimit: Model.apiKeyInfo.clientTypeLimit,
                    apiTypeLimit:Model.apiKeyInfo.apiTypeLimit
                }

                switch(Model.apiKeyInfo.clientTypeLimit){
                    case 1 : break;
                    case 2 :
                        request.clientLimit = JSON.stringify({ URLlist : Model.URLlist });
                        break;
                    case 3 :
                        request.clientLimit = JSON.stringify({ clientlist : Model.clientlist });
                        break;
                    case 4 :
                        request.clientLimit = JSON.stringify({ bundleIdlist : Model.bundleIdlist });
                        break;
                }

                //限制使用的API列表
                if(Model.apiKeyInfo.apiTypeLimit === 1){
                    var apiLimits = []
                    Model.apiSelect.forEach(function (api) {
                        apiLimits.push(api.apiID)
                    });
                    request.apiLimits = apiLimits.join(',');
                }

                projectManageService.modApiKey(request).then(function(resp) {
                    if(resp && resp.resultCode == '0'){
                        auiDialog.success("保存成功", function () {
                            defer.resolve();
                            cancel();
                        });
                    }else{
                        defer.reject();
                    }
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            function cancel(){
                $state.go('credentials', {projectKey:Model.projectKey}, {reload: true});
            }

            function addBundleIdlist(){
                if(Model.bundleIdlist.length < 5){
                    Model.bundleIdlist.push({
                        bundleId : ''
                    });
                }
            }

            function delBundleIdList(index){
                Model.bundleIdlist.splice(index, 1);
            }

            function addClientList(){
                if(Model.clientlist.length < 5){
                    Model.clientlist.push({
                        packageName : '',
                        fingerprint : ''
                    });
                }
            }

            function delClientList(index){
                Model.clientlist.splice(index, 1);
            }

            function addURLList(){
                if(Model.URLlist.length < 5){
                    Model.URLlist.push({
                        URL : ''
                    });
                }
            }

            function delURLList(index){
                Model.URLlist.splice(index, 1);
            }

            //删除密钥
            function delClient(){
                var defer = $q.defer();
                auiDialog.confirm("确定删除密钥吗？", function () {
                    projectManageService.delClient(Model.clientID).then(function(resp){
                        if (resp && resp.resultCode == 0) {
                            auiDialog.success("删除成功", function () {
                                defer.resolve();
                                cancel();
                            });
                        } else {
                            
                            defer.resolve();
                        }
                    });
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //验证包名
            $scope.validPackageName=(function(){
                return {
                    test:function(value){
                        return (new RegExp($scope.regexp.packageName)).test(value);
                    }
                }
            })();

            //验证bundleId
            $scope.validBundleId=(function(){
                return {
                    test:function(value){
                        return (new RegExp($scope.regexp.bundleId)).test(value);
                    }
                }
            })();

            //验证指纹证书
            $scope.validCertFingerprint=(function(){
                return {
                    test:function(value){
                        return (new RegExp($scope.regexp.oauthCertFingerprint)).test(value) ||
                            (new RegExp($scope.regexp.oauthCertFingerprintForRpk)).test(value);
                    }
                }
            })();

            //验证网址
            $scope.validURL=(function(){
                return {
                    test:function(value){
                        return (new RegExp($scope.regexp.webAppUrl)).test(value);
                    }
                }
            })();

        }
    ]);
});

